import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { hashErrorString } from '../../app-base/config/error-override';

const actions = {
    logPagePerformance: {
        method: 'POST',
        url: `${BASE_PATH_API}/logging/pageperformance`
    },
    profile: {
        method: 'POST',
        url: `${BASE_PATH_API}/logging/profiling`
    },
    logError: {
        method: 'POST',
        url: `${BASE_PATH_API}/logging/error`
    },
    logWarning: {
        method: 'POST',
        url: `${BASE_PATH_API}/logging/warning`
    }
};

export function LoggingApi($window) {
    const service = createActions(actions);

    service.logWarningMessage = function logWarningMessage(exception) {
        const hashedErrorCode = hashErrorString(exception.toString());
        const jsErrorDto = {
            message: exception.message,
            location: $window.location.pathname,
            hash: hashedErrorCode,
            callstack: exception.stack,
            userAgent: $window.navigator.userAgent
        };
        return service.logWarning(jsErrorDto);
    };

    return service;
}
LoggingApi.$inject = ['$window'];
